import React from 'react';

import { SearchResult } from '../../../../../types/entity.types';

import { formatDate } from '../../../../../utils/date.util';

import TextHighlighter from '../../../../common/highlighter/TextHighlighter';

import './tribe-search-result.scss';

type Props = {
  searchValue: string;
  result: SearchResult;
  onLoadPostWithHierarchy: (value: string) => void;
};

const TribeSearchResult = ({ searchValue, result, onLoadPostWithHierarchy }: Props) => (
  <div className="tribe-search-result" onClick={() => onLoadPostWithHierarchy(result.externalReference)}>
    <div className="tribe-search-result__header">
      <p className="tribe-search-result__type">{result.postType}</p>
      <p>&nbsp;-&nbsp;</p>
      <p className="tribe-search-result__name">{result.member}</p>
    </div>
    <p className="tribe-search-result__date">{formatDate(result.dateTime)}</p>
    <p className="tribe-search-result__content">
      <TextHighlighter source={result.text} target={searchValue} />
    </p>
  </div>
);

export default TribeSearchResult;
